import {ApplicationConfig, inject, Injectable, isDevMode} from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import routes from "./app-routing.module";
import {HttpClient, provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {provideTransloco, Translation, TranslocoLoader} from "@ngneat/transloco";
import {intercept, LANG} from "@services";
import {provideAnimations} from "@angular/platform-browser/animations";
import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig} from "@abacritt/angularx-social-login";
import {environment} from "@environment";
import {AppRouteReuseStrategy} from "./app-route-reuse.strategy";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";

const AVAILABLE_LANGUAGES: string[] = ['hr', 'en', 'it', 'slo', 'sr', 'bs'];

function getDefaultLang() {
  var defaultLang: string = 'hr';
  if (typeof window !== 'undefined') {
    if (localStorage.getItem(LANG) != null && localStorage.getItem(LANG) != undefined && AVAILABLE_LANGUAGES.includes(localStorage.getItem(LANG)!)) {
      defaultLang = localStorage.getItem(LANG)!;
    }
  }
  return defaultLang;
}

@Injectable({ providedIn:'any' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http: HttpClient = inject(HttpClient);

  getTranslation(lang: string) {
    const files = [`/assets/i18n/${lang}.json`, `/assets/i18n/text_${lang}.json`, `/assets/i18n/countries_${lang}.json`];
    return forkJoin(files.map(file => this.http.get<Translation>(file))).pipe(
      map(translations => Object.assign({}, ...translations))
    );
  }
}

export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(withFetch(), withInterceptors([intercept])),
    {provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy}, /* What should app do in case of a reroute on
     the same url, regarding component, create new or use existing, check runGuardsAndResolvers at
      app-routing.module.ts to set how resolvers are going to behave */
    provideRouter(routes, withComponentInputBinding()/*, withDebugTracing()*/,
      withInMemoryScrolling({scrollPositionRestoration: "enabled"})),
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true,
      includeHeaders:['X-App-Version']
    })), provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: getDefaultLang(),
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        fallbackLang: "hr",
        missingHandler: {
          allowEmpty: true,
          // It will use the first language set in the `fallbackLang` property
          useFallbackTranslation: true
        },
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }), provideAnimations(),     {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleLoginProviderId, {
              oneTapEnabled: false, // default is true
            })
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookLoginProviderId),
          },
        ],
        onError: (err): void => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }]
};
